var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.81 20.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_220452760",
    "data-name": 220452760
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220453240",
    "data-name": 220453240,
    className: "cls-1",
    d: "m21.59,6.84H.22c-.12,0-.22-.1-.22-.22s.1-.22.22-.22h21.37c.12,0,.22.1.22.22s-.1.22-.22.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452736",
    "data-name": 220452736
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220453168",
    "data-name": 220453168,
    className: "cls-1",
    d: "m16.71,20.48H1.72c-.46,0-.89-.18-1.22-.51-.33-.33-.51-.76-.51-1.22V3.88c0-.46.18-.9.51-1.23.33-.33.76-.51,1.22-.51h2.23c.12,0,.22.1.22.22s-.1.22-.22.22H1.72c-.71,0-1.28.58-1.28,1.29v14.87c0,.69.59,1.28,1.28,1.28h14.98c.12,0,.22.1.22.22s-.1.22-.22.22h0Zm4.88-4.88c-.12,0-.22-.1-.22-.22V3.88c0-.71-.57-1.29-1.28-1.29h-2.23c-.12,0-.22-.1-.22-.22s.1-.22.22-.22h2.23c.46,0,.89.18,1.22.51.33.33.51.77.51,1.23v11.49c0,.12-.1.22-.22.22h0ZM15.75,2.59H6.07c-.12,0-.22-.1-.22-.22s.1-.22.22-.22h9.68c.12,0,.22.1.22.22,0,.12-.1.22-.22.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452592",
    "data-name": 220452592
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452688",
    "data-name": 220452688,
    className: "cls-1",
    d: "m16.8,4.74c-.71,0-1.28-.57-1.28-1.28V1.28c0-.71.57-1.28,1.28-1.28s1.28.57,1.28,1.28v2.18c0,.71-.57,1.28-1.28,1.28Zm0-4.3c-.46,0-.83.37-.83.83v2.18c0,.46.37.83.83.83s.83-.37.83-.83V1.28c0-.46-.37-.83-.83-.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220453120",
    "data-name": 220453120
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220453144",
    "data-name": 220453144,
    className: "cls-1",
    d: "m5.01,4.74c-.71,0-1.28-.57-1.28-1.28V1.28c0-.71.57-1.28,1.28-1.28s1.28.57,1.28,1.28v2.18c0,.71-.57,1.28-1.28,1.28ZM5.01.45c-.46,0-.83.37-.83.83v2.18c0,.46.37.83.83.83s.83-.37.83-.83V1.28c0-.46-.37-.83-.83-.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452808",
    "data-name": 220452808
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452712",
    "data-name": 220452712,
    className: "cls-1",
    d: "m16.71,20.48s-.06,0-.08-.02c-.08-.03-.14-.12-.14-.21v-3.64c0-.81.66-1.46,1.46-1.46h3.64c.09,0,.17.05.21.14.03.08.02.18-.05.24l-4.88,4.88s-.1.07-.16.07Zm1.24-4.88c-.56,0-1.02.45-1.02,1.02v3.11l4.12-4.12h-3.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220453024",
    "data-name": 220453024
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220453048",
    "data-name": 220453048,
    className: "cls-1",
    d: "m4.98,10.79h-2.56c-.16,0-.29-.13-.29-.28v-2.32c0-.15.13-.28.29-.28h2.56c.15,0,.28.13.28.28v2.32c0,.15-.13.28-.28.28h0Zm-2.41-.45h2.24v-1.99h-2.24v1.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220453096",
    "data-name": 220453096
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452616",
    "data-name": 220452616,
    className: "cls-1",
    d: "m9.78,10.79h-2.56c-.15,0-.28-.13-.28-.28v-2.32c0-.15.13-.28.28-.28h2.56c.16,0,.29.13.29.28v2.32c0,.15-.13.28-.29.28h0Zm-2.39-.45h2.24v-1.99h-2.24v1.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220453288",
    "data-name": 220453288
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220453000",
    "data-name": 220453000,
    className: "cls-1",
    d: "m14.59,10.79h-2.56c-.16,0-.29-.13-.29-.28v-2.32c0-.15.13-.28.29-.28h2.56c.15,0,.28.13.28.28v2.32c0,.15-.13.28-.28.28h0Zm-2.41-.45h2.24v-1.99h-2.24v1.99h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452880",
    "data-name": 220452880
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452568",
    "data-name": 220452568,
    className: "cls-1",
    d: "m19.39,10.79h-2.56c-.15,0-.28-.13-.28-.28v-2.32c0-.15.13-.28.28-.28h2.56c.16,0,.29.13.29.28v2.32c0,.15-.13.28-.29.28h0Zm-2.39-.45h2.24v-1.99h-2.24v1.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452904",
    "data-name": 220452904
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452928",
    "data-name": 220452928,
    className: "cls-1",
    d: "m4.98,14.54h-2.56c-.16,0-.29-.13-.29-.28v-2.32c0-.15.13-.28.29-.28h2.56c.15,0,.28.13.28.28v2.32c0,.15-.13.28-.28.28h0Zm-2.41-.45h2.24v-1.99h-2.24v1.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452472",
    "data-name": 220452472
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452784",
    "data-name": 220452784,
    className: "cls-1",
    d: "m9.78,14.54h-2.56c-.15,0-.28-.13-.28-.28v-2.32c0-.15.13-.28.28-.28h2.56c.16,0,.29.13.29.28v2.32c0,.15-.13.28-.29.28h0Zm-2.39-.45h2.24v-1.99h-2.24v1.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452400",
    "data-name": 220452400
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452064",
    "data-name": 220452064,
    className: "cls-1",
    d: "m14.59,14.54h-2.56c-.16,0-.29-.13-.29-.28v-2.32c0-.15.13-.28.29-.28h2.56c.15,0,.28.13.28.28v2.32c0,.15-.13.28-.28.28h0Zm-2.41-.45h2.24v-1.99h-2.24v1.99h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452328",
    "data-name": 220452328
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452088",
    "data-name": 220452088,
    className: "cls-1",
    d: "m19.39,14.54h-2.56c-.15,0-.28-.13-.28-.28v-2.32c0-.15.13-.28.28-.28h2.56c.16,0,.29.13.29.28v2.32c0,.15-.13.28-.29.28h0Zm-2.39-.45h2.24v-1.99h-2.24v1.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452256",
    "data-name": 220452256
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220452016",
    "data-name": 220452016,
    className: "cls-1",
    d: "m4.98,18.28h-2.56c-.16,0-.29-.13-.29-.29v-2.31c0-.15.13-.28.29-.28h2.56c.15,0,.28.13.28.28v2.31c0,.16-.13.29-.28.29Zm-2.41-.45h2.24v-1.99h-2.24v1.99h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220452112",
    "data-name": 220452112
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220451992",
    "data-name": 220451992,
    className: "cls-1",
    d: "m9.78,18.28h-2.56c-.15,0-.28-.13-.28-.29v-2.31c0-.15.13-.28.28-.28h2.56c.16,0,.29.13.29.28v2.31c0,.16-.13.29-.29.29Zm-2.39-.45h2.24v-1.99h-2.24v1.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220451848",
    "data-name": 220451848
  }, /*#__PURE__*/React.createElement("path", {
    id: "_220451944",
    "data-name": 220451944,
    className: "cls-1",
    d: "m14.59,18.28h-2.56c-.16,0-.29-.13-.29-.29v-2.31c0-.15.13-.28.29-.28h2.56c.15,0,.28.13.28.28v2.31c0,.16-.13.29-.28.29Zm-2.41-.45h2.24v-1.99h-2.24v1.99h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.43e65238384968e536d0c5897dfe1568.svg";
export { ForwardRef as ReactComponent };